import {useEffect , useState, useRef} from 'react'
import util from "../../utils/utils";
import { useNavigate ,useLocation, useSearchParams} from 'react-router-dom';
import { Mail,ChevronLeft,ChevronsUp,Download, Share2,ChevronsRight,MessageSquare,Compass} from 'react-feather';
import {LoadingDiv } from '@components/LoadingDiv';
import useGetWordCloud from './hooks/useGetWordCloud';
import 'echarts-wordcloud';
import ReactEcharts from 'echarts-for-react';
import * as echarts from 'echarts';
import { ReactComponent as SparkSvg } from '@images/icons/spark.svg';
import { ReactComponent as StatisticsSvg } from '@images/icons/statistics.svg';
import ReactMarkdown from 'react-markdown';
import MyReactMarkdown from '@components/MyReactMarkdown';
import * as Showdown from "showdown"

import usePolicyQa from './hooks/usePolicyQa';
import ReactMde from "react-mde";
import "react-mde/lib/styles/css/react-mde-all.css";
import { ScrolltoTopBtn } from '@components/ScrolltoTopBtn';    
import {PolicyCompareAnalysis} from './components/PolicyCompareAnalysis'

export const PolicyComparePage = () => {
    const iframeRef = useRef();
    const IFRAME_ID = 'myQAIframeDivV5'
    const [showQa,setShowQa] = useState(true)

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();
  const [files, setFiles] = useState([])
  const {wordCloudLoading, getWordCloudAction } = useGetWordCloud();
  const [thinkContent,setThinkContent] = useState('')
  const [filesName, setFilesName] = useState('')
    const [answerContent,setAnswerContent] = useState('')
//   const {
//     qaLoading,
//     qaData
// } = usePolicyQa();
    const [selectedTab,setSelectedTab] = useState('preview')
  const [wordClouds,setWordClouds] = useState([])

  const [md1,setMd1] = useState('')
  const [md2,setMd2] = useState('')
  const converter = new Showdown.Converter({
    tables: true,
    simplifiedAutoLink: true,
    strikethrough: true,
    tasklists: true
  })
//   useEffect(()=>{
//     if(qaData?.answer){
//       // Check if the answer is in the expected format with <think> tags
//       if(typeof qaData.answer === 'string' && qaData.answer.includes('<think>') && qaData.answer.includes('</think>')){
//         // Extract thinking content - everything between <think> and </think>
//         const thinkMatch = qaData.answer.match(/<think>([\s\S]*?)<\/think>/);
//         const thinkContent = thinkMatch ? thinkMatch[1].trim() : '';
//         console.log(thinkContent)
//         setThinkContent(thinkContent);
        
//         // Extract answer content - everything after </think>
//         const answerContent = qaData.answer.split('</think>').pop().trim();
        
//         // Process markdown tables to ensure proper formatting
//         let processedAnswer = answerContent;
//         if(processedAnswer.includes('|')) {
//             // Ensure table has proper line breaks before and after
//             processedAnswer = processedAnswer.replace(/```markdown\|/g, '```markdown\n|');
//             processedAnswer = processedAnswer.replace(/\|\n```/g, '\n```');
//         }
//         // Fix markdown tables by removing the ```markdown wrapper completely
//         if(processedAnswer.includes('```markdown')) {
//           // Remove the markdown code block wrappers around tables
//           processedAnswer = processedAnswer.replace(/```markdown\n?/g, '');
//           processedAnswer = processedAnswer.replace(/\n?```/g, '');
//         }
        
//         console.log("processedAnswer",processedAnswer)
//         setAnswerContent(processedAnswer);
//       } else {
//         setThinkContent('');    
//         let processedAnswer = qaData.answer;
//         if(processedAnswer.includes('|')) {
//             // Ensure table has proper line breaks before and after
//             processedAnswer = processedAnswer.replace(/```markdown\|/g, '```markdown\n|');
//             processedAnswer = processedAnswer.replace(/\|\n```/g, '\n```');
//         }
//         // Fix markdown tables by removing the ```markdown wrapper completely
//         if(processedAnswer.includes('```markdown')) {
//           // Remove the markdown code block wrappers around tables
//           processedAnswer = processedAnswer.replace(/```markdown\n?/g, '');
//           processedAnswer = processedAnswer.replace(/\n?```/g, '');
//         }
//         console.log("processedAnswer",processedAnswer)
//         setAnswerContent(processedAnswer);
//       }
//     }
//   },[qaData])
  useEffect(()=>{
    try{
        const data = JSON.parse(searchParams.get('files'))
        setFiles(data)
        const params = {policy_ids:data?.map(item => item.policy_id)}
        setFilesName(data?.map(item => item.policy_title)?.join('\n\n'))
        // console.log(params)
        getWordCloudAction(params).then(res=>{
            setWordClouds(res?.result_list)
        })

    }catch(e){
        console.log(e)
    }
  },[])


//   const [upBtnVisible,setUpBtnVisible] = useState(false)
  const [index,setIndex] = useState(0)

// const viewFullPolicyAction = (item) => {
//     reset();
//     setFileName(item)
//     getFullPolicyAction({policy_name:item,search_content:searchParams.get('searchContent')})
//     .then(res=>{setData(res)});

//     getPolicyTimelineMindmapAction({policy_title:item})
//     .then(res=>{setViewPolicy(res);setMdTxt(res?.policy_mind_map?.replace(/\>+/g, '-') ?? '')})

// }


// useEffect(()=>{
//     window.addEventListener("scroll",e=>{
//         util?.throttle(setUpBtnStatus(),1000)
//     })
// },[])
// const setUpBtnStatus = () => {
//     let scrollTop = document.documentElement.scrollTop
//     // console.log(scrollTop)
//     if(scrollTop > 600){
//         setUpBtnVisible(true)
//     }else{
//         setUpBtnVisible(false)
//     }
// }
const reset = () => {
  setIndex(0);
  document.documentElement.scrollTop = 0
//   document.getElementById('shareTopAnchor').scrollIntoView()
}

const [copied, setCopied] = useState(false)
useEffect(()=>{
    if(copied){
        setTimeout(()=>{
            setCopied(false)
        },2000)
    }
},[copied])
const pageBack = () => {
    const returnUrl = searchParams.get('returnUrl')
    if(returnUrl){
        window.location.href = returnUrl;
    }else{
        window.location.href = `${process.env.REACT_APP_DOMAIN}policy`
    }
}
const getCloudOption = (id) => {
    const wordCloud = wordClouds?.filter(item=>item?.policy_id === id)?.[0]?.word_list  ?? []
    // console.log(wordCloud)
    const cloudData = wordCloud?.slice(0,50)?.map(item=>{return {name:item?.word,value:item?.frequency}})
    return (
    {
        series: [
          {
            type: 'wordCloud',
            gridSize: 2,
            sizeRange: [12, 50],
            rotationRange: [-90, 90],
            shape: 'pentagon',
            textStyle: {
              normal: {
                color: function() {
                  return (
                    'rgb(' +
                    [
                      Math.round(Math.random() * 255),
                      Math.round(Math.random() * 255),
                      Math.round(Math.random() * 255),
                    ].join(',') +
                    ')'
                  );
                },
              },
              emphasis: {
                shadowBlur: 10,
                shadowColor: '#333',
              },
            },
            data: cloudData,
            tooltip: {
                show: true,
                formatter: function (params) {
                  return `${params.name} : ${params.value}`;
                },
              },
          },
        ],
      }
)}
const getTableData = (id) => {
    const wordCloud = wordClouds?.filter(item=>item?.policy_id === id)?.[0]?.word_list 
    // console.log(wordCloud)
    const tableData = wordCloud?.filter(i=>i.ner?.length > 0)
    return tableData
}
const getComapreAnalysisData = () => {
    const test_data = {
            "num": 2,
            "word": "保障",
            "class": "orientation",
            "level": 3,
            "direction": 1,
            "sentences": [
                "第四条 产权交易机构应当按照本规则组织企业国有资产交易活动，维护交易秩序，保障企业国有资产交易活动有序进行",
                "第六十三条 增资企业应当依法合规开展遴选活动，保障各合格意向投资方平等参与权利"
            ]
    }
    if(wordClouds?.length > 0){
        const exceptWords = ["促进", "推进", "推动", "实行", "建立", "建设", "构建", "打造", "美丽", "增进", "增强", "发展", "提升", "提高", "产业", "项目", "创新", "完善"]
        const joinData = wordClouds?.map(item => {
            let analysisData = [...item?.llm_extract_result?.filter(i=>!exceptWords?.includes(i?.word))]
            let wordArr = analysisData?.map(w=>w?.word)
            item?.keywords_match_result?.filter(i=>!exceptWords?.includes(i?.word)).map(i=>{
                if(i?.word && !wordArr?.includes(i?.word)){
                    analysisData = [...analysisData,i]
                }
            })
            return {
                policy_id:item?.policy_id,
                policy_title:item?.policy_title,
                analysisData
            }
        })
        return joinData;
    }
    return [];
}

// 获取词汇所在的句子上下文
const getWordSentences = (wordData) => {
    return wordData?.sentences || [];
}

// 处理并获取词汇对比数据
const processWordComparison = () => {
    const analysisData = getComapreAnalysisData();
    // console.log(analysisData)
    if (analysisData.length < 2) return { common: [], unique1: [], unique2: [] };
    
    const data1 = analysisData[0]?.analysisData || [];
    const data2 = analysisData[1]?.analysisData || [];
    
    // 共同词汇
    const common = [];
    // 政策一独有词汇
    const unique1 = [];
    // 政策二独有词汇
    const unique2 = [];
    
    // 提取所有词汇
    const words1 = data1.map(item => item.word);
    const words2 = data2.map(item => item.word);
    
    // 处理共同词汇
    data1.forEach(item1 => {
        if (words2.includes(item1.word)) {
            const item2 = data2.find(i => i.word === item1.word);
            common.push({
                word: item1.word,
                class: item1.class || item2.class || 'orientation',
                data1: {
                    ...item1,
                    total_num: item1.num || 0
                },
                data2: {
                    ...item2,
                    total_num: item2.num || 0
                }
            });
        } else {
            unique1.push({
                ...item1,
                total_num: item1.num || 0
            });
        }
    });
    
    // 处理政策二独有词汇
    data2.forEach(item2 => {
        if (!words1.includes(item2.word)) {
            unique2.push({
                ...item2,
                total_num: item2.num || 0
            });
        }
    });
    
    return { common, unique1, unique2 };
}

// 初始化词汇对比数据
const [wordComparison, setWordComparison] = useState({ common: [], unique1: [], unique2: [] });

// 处理关键词点击
const handleKeywordClick = (word) => {
    console.log('Clicked keyword:', word);
    // 可以添加搜索或高亮显示功能
}

useEffect(() => {
    if (wordClouds?.length > 0) {
        const comparisonData = processWordComparison();
        setWordComparison(comparisonData);
    }
}, [wordClouds]);

    return (
      <div className="md:px-12 lg:px-18 2xl:px-24 3xl:px-36 bg-base-200 w-full flex flex-col h-full " >

        {/* {upBtnVisible && <div className="fixed bottom-8 right-8 z-20">
            <button className="btn btn-circle btn-outline bg-base-100" 
                onClick={()=>window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })}
            >
                <ChevronsUp size="16"/>
            </button>
        </div>} */}
        <div className="fixed bottom-8 right-8 z-20">
            <ScrolltoTopBtn/>
        </div>
        <div className='m-3 px-6 max-w-[2360px] w-full mx-auto'>
            <div className=' flex items-center'>
                <span className='hover:primary cursor-pointer' onClick={()=>pageBack()}>返回</span>
                <div className="divider divider-horizontal"></div>
                <div className='text-3xl font-bold'>
                    政策横向对比
                </div>
                {/* <div  className="badge badge-neutral ml-2">{files?.length}个政策文件</div> */}
            </div>
            <div className='mt-4 ml-20 text-lg flex flex-col'>
                {/* {
                    files?.map(item=>item?.policy_title)?.join(' —— VS —— ')
                } */}
                <div className=''>
                    <span className="font-bold hover:text-primary cursor-pointer" 
                     onClick={()=>window.open(`${process.env.REACT_APP_DOMAIN}policy/file?fileName=${encodeURIComponent(files[0]?.policy_title)}&fileId=${files[0]?.policy_id}&returnUrl=${encodeURIComponent(window.location.href)}`,'_blank')}
                    >政策一：{files[0]?.policy_title}</span><span className='text-secondary'>&nbsp;&nbsp;{files[0]?.policy_time?.slice(0,10)}&nbsp;&nbsp;{files[0]?.from_organization}</span>
                </div>
                <div className=' font-bold text-secondary'>
                    —— VS —— 
                </div>
                <div className='' >
                    <span className="font-bold hover:text-primary cursor-pointer" 
                        onClick={()=>window.open(`${process.env.REACT_APP_DOMAIN}policy/file?fileName=${encodeURIComponent(files[1]?.policy_title)}&fileId=${files[1]?.policy_id}&returnUrl=${encodeURIComponent(window.location.href)}`,'_blank')}
                    >政策二：{files[1]?.policy_title}</span><span className='text-secondary'>&nbsp;&nbsp;{files[1]?.policy_time?.slice(0,10)}&nbsp;&nbsp;{files[1]?.from_organization}</span>
                </div>
            </div>
        </div>
        <div className='max-w-[2360px] w-full mx-auto xl:flex'>
            <div className='p-4 bg-base-100 m-3 flex flex-col shadow-lg flex-1'>
                {/* <div className="py-8 px-8 realtive w-full h-full bg-base-100">
                        <div className='flex w-full items-center gap-4 mb-6'>
                            <SparkSvg/>
                            <div className="card-title">
                            文件分析对比
                            </div>
                        </div>
                        <div>
                            {qaLoading ? <LoadingDiv/> : 
                            <ReactMde
                            selectedTab="preview"
                            onTabChange={setSelectedTab}
                            value={answerContent ?? '请稍后再试'}
                            readOnly
                            generateMarkdownPreview={markdown =>
                                Promise.resolve(converter.makeHtml(markdown))
                                }
                    
                        />
                        }                     
                        </div>

                </div> */}
                <PolicyCompareAnalysis searchK={filesName}/>
                {util.getCurrentClientId() === 'client-a' && (
                    <>
                        <div className="py-8 px-8 realtive w-full h-full bg-base-100">
                                <div className='flex w-full items-center gap-4'>
                                    <StatisticsSvg/>
                                    <div className="card-title">
                                    高频词对比
                                    </div>
                                </div>
                        </div>
                        <div className='flex w-full px-8 pb-8 gap-4 bg-base-100'>
                            {
                                wordCloudLoading ?
                                <LoadingDiv/> :
                                <>
                                    {files?.map((item,index)=>{
                                        return (
                                            <div className={`w-1/${files?.length} bg-base-100 p-6 border`}>
                                                <div className="card-title mb-4">
                                                    {index === 0 ? '政策一' : '政策二'}
                                                </div>

                                                <div className='px-6'>
                                                    <div className="card bg-base-100 w-full ">
                                                        <div className='h-96'>
                                                            <ReactEcharts
                                                                option={getCloudOption(item?.policy_id)}
                                                                // notMerge
                                                                // lazyUpdate
                                                                className='h-full w-full'
                                                                // onChartReady={(chart) => {
                                                                //     // 绑定点击事件
                                                                //     chart.on('click', (params) => {
                                                                //     if (params.seriesType === 'wordCloud') {
                                                                //         console.log(params)
                                                                //         // onWordCloudClick(params);
                                                                //     }
                                                                //     });
                                                                // }}
                                                            />
                                                        </div>
                                                    </div>


                                                    {/* <div className="divider divider-start">词属性挖掘</div>
                                                    <div className="overflow-x-auto h-96">
                                                        <table className="table table-pin-rows table-zebra">
                                                            <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th>关键词</th>
                                                                <th>属性</th>
                                                                <th>词频</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {
                                                                getTableData(item?.policy_id)?.map((item,index)=>{
                                                                    return (
                                                                        <tr className="hover">
                                                                            <td>{index + 1}</td>
                                                                            <td>{item?.word}</td>
                                                                            <td>{[...new Set(item?.ner)].join(',')}</td>
                                                                            <td>{item?.frequency}</td>
                                                                        </tr>

                                                                    )
                                                                })
                                                            }
                                                            </tbody>
                                                        </table>
                                                    </div> */}
                                                </div>
                                            </div>
                                        )
                                    })}

                                </>
                            }
                        </div>
                    </>
                )}
                <div className="py-8 px-8 realtive w-full h-full bg-base-100">
                        <div className='flex w-full items-center gap-4'>
                            <Compass size='1.5rem'/>
                            <div className="card-title">
                            趋势导向挖掘
                            </div>
                        </div>
                </div>
                <div className='w-full px-8 pb-8 gap-4 bg-base-100'>
                    {
                            wordCloudLoading ? 
                            <LoadingDiv/> :
                        <>
                            {wordComparison.common.length > 0 && (
                                <div className="mb-5">
                                    <div className="font-semibold text-primary mb-2 text-lg">共同词汇</div>
                                    <div className="grid grid-cols-1 gap-3">
                                        {wordComparison.common.map((item, idx) => {
                                            // Get sentences for each item from the appropriate block
                                            const sentences1 = getWordSentences(item.data1);
                                            const sentences2 = getWordSentences(item.data2);
                                            
                                            return (
                                                <div key={idx} className="bg-base-200 p-4 rounded-lg border-l-4 border-primary">
                                                    <div className="flex justify-between mb-2">
                                                        <div>
                                                            <span 
                                                                className="font-medium text-lg cursor-pointer hover:text-primary transition-colors duration-200"
                                                                onClick={() => handleKeywordClick(item.word)}
                                                            >
                                                                {item.word}
                                                            </span>
                                                            <span className="ml-2 text-base px-2 py-0.5 rounded bg-gray-200">
                                                                出现次数 &nbsp;{item.data1.total_num}
                                                                <span className="mx-2">vs</span>
                                                                <span className="font-medium text-secondary">{item.data2.total_num}</span>
                                                            </span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <span className="ml-2 text-base px-2 py-0.5 rounded bg-gray-200">
                                                                {item.class === 'orientation' ? '方向导向' : 
                                                                item.class === 'trend' ? '趋势变化' : 
                                                                item.class === 'intensity' ? '实施力度' : '落地措施'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    
                                                    {(sentences1?.length > 0 || sentences2?.length > 0) && (
                                                        <div className="mt-1 grid grid-cols-2 gap-3">
                                                            {sentences1?.length > 0 && (
                                                                <div className="text-base bg-base-100 p-3 rounded border border-primary/20">
                                                                    <div className="font-medium mb-2 text-primary">政策一中的上下文:</div>
                                                                    {sentences1.map((sentence, i) => (
                                                                        <div key={i} className="mb-2">• {sentence}</div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                            
                                                            {sentences2?.length > 0 && (
                                                                <div className="text-base bg-base-100 p-3 rounded border border-secondary/20">
                                                                    <div className="font-medium mb-2 text-secondary">政策二中的上下文:</div>
                                                                    {sentences2.map((sentence, i) => (
                                                                        <div key={i} className="mb-2">• {sentence}</div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                            
                            <div className="grid grid-cols-2 gap-4 mt-4">
                                <div>
                                    <div className="font-semibold mb-2 text-lg text-primary">政策一独有词汇</div>
                                    {wordComparison.unique1.length > 0 ? (
                                        <div className="space-y-2">
                                            {wordComparison.unique1.map((item, idx) => {
                                                // Get sentences for this unique item
                                                const sentences = getWordSentences(item);
                                                
                                                return (
                                                    <div key={idx} className="bg-base-200 p-4 rounded-lg border-l-4 border-primary">
                                                        <div className="flex justify-between mb-2">
                                                            <span className="font-medium flex items-center text-lg">
                                                                <span 
                                                                    className="cursor-pointer hover:text-primary transition-colors duration-200"
                                                                    onClick={() => handleKeywordClick(item.word)}
                                                                >
                                                                    {item.word}
                                                                </span>
                                                                <span className="ml-2 text-base px-2 py-0.5 rounded bg-gray-200">
                                                                出现次数 &nbsp;{item.total_num}
                                                                </span>
                                                            </span>
                                                            <div>
                                                                <span className="ml-2 text-base px-2 py-0.5 rounded bg-gray-200">
                                                                    {item.class === 'orientation' ? '方向导向' : 
                                                                    item.class === 'trend' ? '趋势变化' : 
                                                                    item.class === 'intensity' ? '实施力度' : '落地措施'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        
                                                        {sentences?.length > 0 && (
                                                            <div className="mt-2 text-base bg-base-100 p-3 rounded border border-primary/20">
                                                                <div className="font-medium mb-2">上下文:</div>
                                                                {sentences.map((sentence, i) => (
                                                                    <div key={i} className="mb-2">• {sentence}</div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div className="text-base italic bg-base-200 p-3 rounded">无独有词汇</div>
                                    )}
                                </div>
                                
                                <div>
                                    <div className="font-semibold mb-2 text-lg text-secondary">政策二独有词汇</div>
                                    {wordComparison.unique2.length > 0 ? (
                                        <div className="space-y-2">
                                            {wordComparison.unique2.map((item, idx) => {
                                                // Get sentences for this unique item
                                                const sentences = getWordSentences(item);
                                                
                                                return (
                                                    <div key={idx} className="bg-base-200 p-4 rounded-lg border-l-4 border-secondary">
                                                        <div className="flex justify-between mb-2">
                                                            <span className="font-medium flex items-center text-lg">
                                                                <span 
                                                                    className="cursor-pointer hover:text-primary transition-colors duration-200"
                                                                    onClick={() => handleKeywordClick(item.word)}
                                                                >
                                                                    {item.word}
                                                                </span>
                                                                <span className="ml-2 text-base px-2 py-0.5 rounded bg-gray-200">
                                                                出现次数 &nbsp; {item.total_num}
                                                                </span>
                                                            </span>
                                                            <div>
                                                                <span className="ml-2 text-base px-2 py-0.5 rounded bg-gray-200">
                                                                    {item.class === 'orientation' ? '方向导向' : 
                                                                    item.class === 'trend' ? '趋势变化' : 
                                                                    item.class === 'intensity' ? '实施力度' : '落地措施'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        
                                                        {sentences?.length > 0 && (
                                                            <div className="mt-2 text-base bg-base-100 p-3 rounded border border-secondary/20">
                                                                <div className="font-medium mb-2">上下文:</div>
                                                                {sentences.map((sentence, i) => (
                                                                    <div key={i} className="mb-2">• {sentence}</div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div className="text-base italic bg-base-200 p-3 rounded">无独有词汇</div>
                                    )}
                                </div>
                            </div>
                        
                        </>
                    }
                </div>

            </div>

            {process.env.REACT_APP_CLIENT_ID !== 'client-b' && (
            <>
            <div className={`${showQa ? '' : 'hidden'} card bg-base-100 ${process.env.REACT_APP_TYPE === 'grid-build' ? 'h-[83vh]' : 'h-[76vh]'} w-full xl:w-[30vw] xl:flex-shrink-0 m-3 shadow-lg sticky top-4`}>
                <div className='flex justify-between p-3 bg-base-100'>
                    <div className='flex space-x-2'>
                        <div className='card-title px-4 flex gap-4'>
                            <MessageSquare size='1.5rem'/>
                            <span> 对比AI问答</span>
                        </div>
                    </div>
                    <div className='flex'>
                        <div className="divider divider-horizontal mx-1 my-2"></div>
                        <button className={`btn btn-ghost`} onClick={()=>{setShowQa(!showQa)}}>
                            <ChevronsRight size="16"/>
                        </button>
                    </div>
                </div>
                <div className="card-body flex flex-col gap-y-4 p-0 ">
                    <div className='flex-1'>
                        <iframe
                            id={IFRAME_ID}
                            ref={iframeRef}
                            allow="clipboard-write; clipboard-read"
                            // src="http://10.10.10.64:3001"
                            // src="http://policyassist.yuyihub.com/llm-qa?version4"
                            src={process.env.REACT_APP_QA_URL}
                            // src={`${process.env.REACT_APP_DOMAIN}qaBuildForGrid/index.html`}
                            width='100%'
                            height='100%'
                        />
                    </div>
                </div>
            </div>
            <div className={`${showQa ? 'hidden' : ''} fixed bottom-48 right-8`}>
                <button className="bg-base-100 group btn hover:btn-primary hover:text-white shadow-lg h-4"
                    onClick={()=>{setShowQa(!showQa)}}
                >
                    <MessageSquare size='1.5rem'/>
                    <span className='group-hover:block hidden'>对比AI问答</span>
                </button>
            </div>
            </>
            )}

        </div>
      </div>

    )
}